// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__UI55D","topBottomGutter":"Layout_topBottomGutter__1Vt64"};